import {ContentUpdateCategory} from "../../interfaces/content-update-category.interface";
import {CollectionViewer, DataSource} from "@angular/cdk/collections";
import {BehaviorSubject, Observable, of} from "rxjs";
import {catchError, finalize} from "rxjs/operators";
import {ContentUpdatesCategoryService} from "../content-updates-category.service";

export class ContentUpdatesCategoriesDataSource implements DataSource<ContentUpdateCategory> {

	public contentUpdatesCategoriesSubject = new BehaviorSubject<ContentUpdateCategory[]>([]);
	private loadingSubject = new BehaviorSubject<boolean>(false);
	private countSubject = new BehaviorSubject<number>(0);
	public currentPageCountSubject = new BehaviorSubject<number>(0);

	public loading$ = this.loadingSubject.asObservable();
	public count$ = this.countSubject.asObservable();
	public currentPageCount$ = this.currentPageCountSubject.asObservable();

	constructor(private contentUpdatesCategoryService: ContentUpdatesCategoryService) {}

	connect(collectionViewer: CollectionViewer): Observable<ContentUpdateCategory[]> {
		return this.contentUpdatesCategoriesSubject.asObservable();
	}

	disconnect(collectionViewer: CollectionViewer): void {
		this.contentUpdatesCategoriesSubject.complete();
		this.loadingSubject.complete();
		this.countSubject.complete();
		this.currentPageCountSubject.complete();
	}

	list(filters = {}, orderBy = '', order = 'asc',
						pageNumber = 0, pageSize = 5) {

		this.loadingSubject.next(true);

		this.contentUpdatesCategoryService.index(filters, orderBy, order,
			pageNumber, pageSize).pipe(
			catchError(() => of([])),
			finalize(() => this.loadingSubject.next(false))
		)
			.subscribe(response => {
				this.contentUpdatesCategoriesSubject.next(response.data);
				this.countSubject.next(response.total);
				this.currentPageCountSubject.next(response.data.length);
			});
	}

	getList() {
		return this.contentUpdatesCategoriesSubject.value;
	}
}
